import PageTitle from "../../components/PageTitle";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import PageContent from "../../components/PageContent";
import useApi from "../../hooks/ApiHook";
import { useEffect, useState } from "react";
import If from "../../components/If";
import Loading from "../../components/Loading";
import usePaginator from "../../hooks/PaginatorHook";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Tag } from 'primereact/tag';

export default function() {

    const api = useApi();
    const navigate = useNavigate();
    const [ connections, setConnections ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const { page, limit, setTotal, Paginator } = usePaginator();
    const [ searchParams, setSearchParams ] = useSearchParams();
    
    useEffect(() => {
        setLoading(true);
        api.get(`suppliers?page=${page}&limit=${limit}`).then(({ data }) => {
            setConnections(data.data);
            setTotal(data.total);
            setSearchParams({ page, limit });
        }).finally(() => setLoading(false));
    }, [page, limit]);

    const actions = connection => (
        <>
            <Button icon="pi pi-pencil" title="Editar" onClick={() => navigate('./' + connection.id)}/>
        </>
    );

    const titleButtons = (
        <Button label="Adicionar" onClick={() => navigate('./new')}/>
    );

    const statusColumnBody = (supplier) => supplier.relationshipStatus === 'WAITING'
        ? <Tag severity="warning" value="AGUARDANDO"/>
        : <Tag value="ATIVO"/>;

    return (
        <div>
            <PageTitle title="Distribuidoras" subtitle="Estabeleça conexões entre sua indústria e seus distribuidores" end={titleButtons}/>
            <PageContent>
                <If condition={loading}>
                    <Loading/>
                </If>
                <If condition={!loading}>
                    <DataTable value={connections} selectionMode="single" emptyMessage="Nada encontrado" responsiveLayout="stack">
                        <Column field="commercialName" header="Empresa"></Column>
                        <Column field="document" header="CPF/CNPJ"></Column>
                        <Column body={statusColumnBody} header="Status"></Column>
                        {/* <Column body={actions} header="Ações" align='right'></Column> */}
                    </DataTable>
                    <Paginator/>
                </If>
            </PageContent>
        </div>
    );
}